// Consentimento de cookies (LGPD) + Google Consent Mode v2.
// O padrão "tudo negado" é aplicado em pages/_document.tsx antes de qualquer
// tag carregar; aqui ficam a escolha do usuário e a atualização das tags.

export const CHAVE_CONSENTIMENTO = "consentimento_cookies";
// Suba a versão quando mudar as categorias/texto: o banner volta a aparecer
export const VERSAO_CONSENTIMENTO = 1;
export const EVENTO_ABRIR_PREFERENCIAS = "abrir-preferencias-cookies";

export type Consentimento = {
  versao: number;
  analytics: boolean; // Google Analytics
  marketing: boolean; // Pixel do Facebook e pixels de anúncio dos eventos
  data: string;
};

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

function gtag(..._args: any[]) {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function lerConsentimento(): Consentimento | null {
  if (typeof window === "undefined") return null;
  try {
    const salvo = JSON.parse(localStorage.getItem(CHAVE_CONSENTIMENTO) ?? "null");
    return salvo?.versao === VERSAO_CONSENTIMENTO ? salvo : null;
  } catch {
    return null;
  }
}

export const marketingPermitido = () => Boolean(lerConsentimento()?.marketing);

// Repassa a escolha para as tags já carregadas
export function aplicarConsentimento(c: Consentimento | null) {
  if (typeof window === "undefined") return;

  const analytics = c?.analytics ? "granted" : "denied";
  const marketing = c?.marketing ? "granted" : "denied";

  gtag("consent", "update", {
    analytics_storage: analytics,
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
  });

  if (typeof window.fbq === "function") {
    window.fbq("consent", c?.marketing ? "grant" : "revoke");
  }
}

export function salvarConsentimento(escolha: { analytics: boolean; marketing: boolean }) {
  const c: Consentimento = {
    versao: VERSAO_CONSENTIMENTO,
    ...escolha,
    data: new Date().toISOString(),
  };
  try {
    localStorage.setItem(CHAVE_CONSENTIMENTO, JSON.stringify(c));
  } catch {}
  aplicarConsentimento(c);
  return c;
}

// Para links como "Preferências de cookies" no rodapé
export function abrirPreferenciasCookies() {
  window.dispatchEvent(new Event(EVENTO_ABRIR_PREFERENCIAS));
}

// Script inline do _document: roda antes de tudo, define o padrão negado e,
// se já houver escolha salva, aplica na hora (sem esperar o React)
export const scriptConsentimentoPadrao = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500
  });
  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);
  try {
    var c = JSON.parse(localStorage.getItem('${CHAVE_CONSENTIMENTO}') || 'null');
    if (c && c.versao === ${VERSAO_CONSENTIMENTO}) {
      var m = c.marketing ? 'granted' : 'denied';
      gtag('consent', 'update', {
        analytics_storage: c.analytics ? 'granted' : 'denied',
        ad_storage: m,
        ad_user_data: m,
        ad_personalization: m
      });
    }
  } catch (e) {}
`;
